"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.map");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.trim_string_parse = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _formElements = require("@evidation/form-elements");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _lodash = _interopRequireDefault(require("lodash"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var trim = function trim(x) {
  return x.replace(/^\s+|\s+$/gm, '');
};

var DropzoneContainer = _styledComponents["default"].div.withConfig({
  displayName: "connected_file__DropzoneContainer",
  componentId: "sc-1l76lvz-0"
})(["margin-bottom:5px;> div{display:block;padding:10px 20px;text-align:center;border:1px dashed gray;border-radius:3px;}p{margin:0;}"]);

var trim_string_parse = function trim_string_parse(v) {
  if (!v) {
    return v;
  }

  return trim(v);
};

exports.trim_string_parse = trim_string_parse;

var convert_readable_accepted_types = function convert_readable_accepted_types(string) {
  return _lodash["default"].replace(string, /image\//g, "");
};

var ConnectedFile = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(ConnectedFile, _PureComponent);

  var _super = _createSuper(ConnectedFile);

  function ConnectedFile() {
    var _this;

    (0, _classCallCheck2["default"])(this, ConnectedFile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      accepted: [],
      rejected: [],
      manual: false,
      error: undefined
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (value, id) {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAddValue", function (value) {
      if (value) {
        return _this.setState({
          accepted: [],
          rejected: [],
          error: undefined
        }, function () {
          return _this.props.input.onChange(value);
        });
      }

      _this.setState({
        accepted: [],
        rejected: [],
        error: "There was a problem with your image, please try again."
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDrop", function (accepted, rejected) {
      _this.setState({
        error: undefined,
        accepted: accepted,
        rejected: rejected
      }, function () {
        _this.props.config.onFileAdd(accepted, _this.onAddValue);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onPromptForManual", function (event) {
      var manual = prompt('Please enter url to image', 'http://');

      if (manual === null || manual === '') {
        event.preventDefault();
        return;
      }

      _this.onAddValue(trim_string_parse(manual));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderDropZone", function () {
      var _this$props$config$ac = _this.props.config.accept,
          accept = _this$props$config$ac === void 0 ? "image/jpeg, image/png" : _this$props$config$ac;
      var accepted = _this.state.accepted;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(DropzoneContainer, null, /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
        style: {},
        accept: accept,
        onDrop: _this.onDrop
      }, !_lodash["default"].isEmpty(accepted) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Processing..."), /*#__PURE__*/_react["default"].createElement("ul", null, accepted.map(function (f) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: f.name
        }, f.name, " - ", f.size, " bytes");
      }))) : /*#__PURE__*/_react["default"].createElement("p", null, "Click to select file or drop a file here. Accepted file formats:", ' ', convert_readable_accepted_types(accept)))), /*#__PURE__*/_react["default"].createElement("button", {
        onClick: _this.onPromptForManual
      }, "Click to add image URL"));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearFile", function (event) {
      var result = window.confirm(_this.props.config.confirmation_message || "Are you sure you want to delete this?");

      if (result) {
        _this.setState({
          accepted: [],
          rejected: [],
          error: undefined
        }, function () {
          return _this.props.input.onChange("");
        });
      } else {
        event.preventDefault();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderInputField", function () {
      var _this$props = _this.props,
          inputStyle = _this$props.inputStyle,
          value = _this$props.input.value,
          _this$props$config = _this$props.config,
          onViewPreview = _this$props$config.onViewPreview,
          disabled = _this$props$config.disabled;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formElements.TextInput, {
        inputStyle: inputStyle,
        disabled: true,
        value: value,
        onChange: function onChange() {
          return false;
        }
      }), /*#__PURE__*/_react["default"].createElement("button", {
        disabled: disabled,
        onClick: _this.clearFile
      }, "Clear"), onViewPreview && _lodash["default"].isFunction(onViewPreview) && /*#__PURE__*/_react["default"].createElement("button", {
        onClick: function onClick() {
          return onViewPreview(value);
        }
      }, "Preview"));
    });
    return _this;
  }

  (0, _createClass2["default"])(ConnectedFile, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          labelStyle = _this$props2.labelStyle,
          _this$props2$input$va = _this$props2.input.value,
          value = _this$props2$input$va === void 0 ? undefined : _this$props2$input$va,
          label = _this$props2.label,
          _this$props2$meta = _this$props2.meta,
          validationError = _this$props2$meta.error,
          touched = _this$props2$meta.touched;
      return /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        labelStyle: labelStyle,
        label: "".concat(label)
      }, _lodash["default"].isUndefined(value) || _lodash["default"].isEmpty(value) ? this.renderDropZone() : this.renderInputField(), this.state.error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, this.state.error), touched && validationError && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, validationError));
    }
  }]);
  return ConnectedFile;
}(_react.PureComponent);

ConnectedFile.propTypes = {
  config: (0, _propTypes.shape)({
    onFileAdd: _propTypes.func.isRequired,
    onViewPreview: _propTypes.func,
    confirmation_message: _propTypes.string,
    accept: _propTypes.string,
    multiple: _propTypes.bool,
    disabled: _propTypes.bool
  })
};
ConnectedFile.defaultProps = {};
var _default = ConnectedFile;
exports["default"] = _default;